<template>
    <div class="header container ofh">
        <div class="left cp fl">
            <a href="#">
                <img class="logo" src="img/gen/pic_logo.png" alt>
            </a>
        </div>
        <div class="fr">
            <ul class="nav">
                <li class="nav-btn cp fl non" @click="miniApp()">
                    <img  src="img/gen/ico_xuanzhong.png" alt>
                </li>
                <li class="nav-btn cp fl nav-alpha"  @click="loginPanel">
                    <a href="#">
                        <i class="default-icon default-avater" v-if="!userPics"></i>
                        <img class="avater2" v-else :src="this.userPic2">
                    </a>
                    <div :class="userClass" v-if="userPanel">
                        <div class="sharp white1 abs"></div>
                        <div class="top">
                            <img class="fl avater" :src="this.userPic">
                            <p>{{userName}}</p>
                        </div>
                        <div class="middle cb non">
                            <div>
                                <p class="middleA">会员信息</p>
                                <p class="middleB">迅捷图片转换器</p>
                                <p class="expire_time">2018-12-26到期</p>
                            </div>
                            <div class="xufei abs">
                                <p class="fl">1年授权</p>
                                <div class="bds bd2 br14 fl cp ct">
                                    <a href="#">续费</a>
                                </div>
                            </div>
                        </div>
                        <div class="bottom" @click="loginOut">退出登录</div>
                    </div>
                </li>
                <li class="nav-btn cp fl nav-alpha non">
                    <a href="#">
                         <i class="default-vip"></i>
                    </a>
                </li>
                <li class="nav-btn cp fl nav-beta non" @click="showHelps">
                    <a href="#">
                        <i class="default-icon default-menu"></i>
                    </a>
                    <div :class="helpClass" v-if="showHelp">
                        <div class="sharp white1 abs"></div>
                        <ul class="help-list ct">
                            <li>帮助</li>
                            <div class="horizon"></div>
                            <li>联系客服</li>
                            <div class="horizon"></div>
                            <li>用户反馈</li>
                        </ul>
                    </div>
                </li>
                <li
                    class="nav-btn cp fl nav-gamma"
                    @click="quitApp()"
                    @mouseenter="closeWin=true"
                    @mouseleave="closeWin=false"
                >
                    <i class="default-icon default-close"></i>
                </li>
            </ul>
        </div>
        <UserLogin v-if="loginPanelStatus"/>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from "vuex"
import UserLogin from "../userLogin"
import { getStore } from '../../assets/js/utils'
//removeStore, 引用从未被使用
export default {
    name: "Top",
    data() {
        return {
            userClass: 'user_dialog white1 bds bd1 br3 sd1 abs cd',
            helpClass: 'help_dialog white1 bds bd1 br3 sd1 abs cd',
            showHelp: false,
            closeWin: false,
            showLogin: false,
            userPanel: false,
            userName: '迅捷图片',//登陆后信息
            userPic: require('../../../public/img/gen/pic_morentouxiang.png'),
            userPic2: '',
            vip: 'nothing'
        }
    },
    computed: {
       ...mapState('user',[
           'loginPanelStatus',
           'userInfo'
       ]),
       userPics(){
           if(this.userPic2 == ''){
              return false
           }else{
               return true
           }
       }
    },
    methods: {
        ...mapMutations('user',[
            "LoginPanelStatus_Show",
            "OUT_LOGIN"
        ]),
        ...mapActions('user',[
           'getUserInfo'
        ]),
        quitApp() {
            window.ipc.send("window-close");
        },
        miniApp() {
            window.ipc.send("window-min");
        },
        showHelps(){
           this.showHelp = !this.showHelp
        },
        loginPanel(){
           if( getStore('token') ) {
              this.userPanel = !this.userPanel
           }else{
               this.userPanel = false
               this.toLogin()
           }
        },
        setUserInfo(){
           if(this.userInfo == null) {
                this.userName ='迅捷图片'
                this.userPic = require('../../../public/img/gen/pic_morentouxiang.png')
                this.userPic2 = require('../../../public/img/menu/btn_geren03.png')
                this.vip = 'nothing'
                return
           }
           if(this.userInfo.picture) {
                this.userPic = this.userInfo.picture 
                this.userPic2 =  this.userInfo.picture 
           }
           this.userName = getStore('nick_name') || this.userInfo.nick_name || null 
           this.vip = getStore('vip') || this.userInfo.vips || 'nothing' 
        },
        toLogin() {
            this.LoginPanelStatus_Show()
        },
        loginOut(){
           this.OUT_LOGIN()
        }
    },
    mounted(){
        this.getUserInfo().then(()=>{
            //回调参数 res
            this.setUserInfo();
        })
    },
    watch:{
      userInfo: {
          handler: function () {
            //显示用户信息
            this.setUserInfo()
          },
          deep: true,//深度监听
          immediate: true
      },
    },
    components:{
        UserLogin
    },
};
</script>

<style scoped>
p {
    color: #464851;
}
.logo {
    padding-left: 9px;
    padding-top: 6px;
}
.header {
    height: 40px;
    border-bottom: 1px solid #e2e5ec;
    -webkit-app-region: drag;
}
.nav-btn {
    height: 32px;
    border-left: 1px solid #e2e5ec;
    -webkit-app-region: no-drag;
}
.nav-alpha {
    padding: 8px 7px 0px 7px;
}
.nav-beta {
    padding: 8px 9px 0px 9px;
}
.nav-gamma {
    padding: 8px 8px 0px 8px;
}
.user_dialog {
    right: 76px;
    top: 65px;
    width: 223px;
    z-index: 10;
}
.user_dialog .sharp {
    right: 20px;
    top: -7px;
}
.top img {
    padding: 8px 9px 10px 9px;
}
.top p {
    line-height: 64px;
}
.middle p {
    font-size: 12px;
    padding-bottom: 8px;
}
.middle p.middleB {
    padding-bottom: 3px;
}
.top p,
.bottom,
.middle p.middleA {
    font-size: 14px;
}
.expire_time {
    color: #ff8519;
}
.bottom {
    color: #a5b8c8;
    padding-bottom: 10px;
}
.middle,
.bottom {
    width: 200px;
    margin-left: 8px;
    padding-top: 8px;
    border-top: 1px solid #e2e5ec;
}
.xufei {
    right: 10px;
    top: 96px;
}
.xufei p {
    line-height: 28px;
    padding-right: 7px;
}
.xufei a {
    padding: 0px 14px 0px 14px;
    font-size: 12px;
    line-height: 26px;
    color: #0fa790;
}
.help_dialog {
    right: 18px;
    top: 60px;
    width: 82px;
    z-index: 10;
}
.help_dialog .sharp {
    left: 35px;
    top: -7px;
}
.help_dialog li {
    font-size: 12px;
    color: #a5b8c8;
    line-height: 38px;
}
.horizon {
    height: 1px;
    background-color: #e2e5ec;
}
/* 顶部menu样式 */
.default-icon{
  width: 24px;
  height: 24px;
  display: inline-block;
  background-size: 24px 24px;
}
.default-avater{
  background: url("../../../public/img/menu/btn_geren01.png") no-repeat;
}
.default-avater:hover{
   background: url("../../../public/img/menu/btn_geren02.png") no-repeat;
}
.default-avater:active{
   background: url("../../../public/img/menu/btn_geren03.png") no-repeat;
}
.default-menu{
  background: url("../../../public/img/menu/btn_caidan01.png") no-repeat;
}
.default-menu:hover{
  background: url("../../../public/img/menu/btn_caidan02.png") no-repeat;
}
.default-menu:active{
  background: url("../../../public/img/menu/btn_caidan03.png") no-repeat;
}
.default-close{
  background: url("../../../public/img/menu/btn_x01.png") no-repeat;
}
.default-close:hover{
   background: url("../../../public/img/menu/btn_x02.png") no-repeat;
}
.default-close:active{
   background: url("../../../public/img/menu/btn_x03.png") no-repeat;
}
.default-vip{
  width: 68px;
  height: 24px;
  display: inline-block;
  background-size: 68px 24px;
  background: url("../../../public/img/menu/btn_vip01.png") no-repeat;
}
.default-vip:hover{
   background: url("../../../public/img/menu/btn_vip02.png") no-repeat;
}
.default-vip:active{
   background: url("../../../public/img/menu/btn_vip03.png") no-repeat;
}
.avater2{
  width: 24px;
  height: 24px;
  display: inline-block;
}
.avater{
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: inline-block;
}
.help-list li{
   cursor: pointer;
}
.help-list li:hover{
   color: #0091FF;
}
</style>
